<template>
  <div style="min-height: 30vh;">
    <p class="text-left mt-3" style="font-size: .95em">Esta funcionalidad sirve para actualizar el valor "Tipo paciente". Este valor se toma para determinar si aplica o no a una promoción o un cupón, segmentado NO sirve para determinar si se le da descuento de plan</p>
    <loading
          :active.sync="loading"
          :can-cancel="false"
          :is-full-page="true"
      ></loading>
    <b-form class="mt-5" v-on:submit.prevent="traerDatosPaciente">
      <b-row class="w-100 mt-2"> 
        <b-col>
          <label>Id de paciente: *</label>
          <b-form-input 
          
            class="mr-5 w-100"
            v-model.number="idPaciente"
            maxLength="14"
            pattern="[0-9]{1,}"
            :state="idPaciente != null && idPaciente != ''"
            required
          >
          </b-form-input>
          <b-form-invalid-feedback :state="idPaciente != null && idPaciente != ''">
          Debe colocar el id
        </b-form-invalid-feedback>
        </b-col>
       
          <b-col class="d-flex justify-content-start" style="height: 2.5em; margin-top: 2.5%;">
              <b-button type="submit" variant="outline-primary">
              Buscar
            </b-button>
          </b-col>
      </b-row>
    </b-form>

    <b-table-simple hover small caption-top responsive v-if="datosPaciente != null" style="margin-top: 6%;">
      <b-tr>
        <b-th>ID Paciente</b-th>
        <b-th>Nombre del paciente</b-th>
        <b-th>Fecha de nacimiento</b-th>
        <b-th>Tipo de paciente</b-th>
        <b-th>Acciones</b-th>
      </b-tr>
      <b-tr>
        <b-td>{{ datosPaciente.idPaciente }}</b-td>
        <b-td>{{ datosPaciente.nombreCompleto }}</b-td>
        <b-td>{{ datosPaciente.fechaNacimiento | formatoFecha }}</b-td>
        <b-td>{{ datosPaciente.tipoPacienteKPI ? datosPaciente.tipoPacienteKPI : "Sin kpi" }}</b-td>
        <b-td><b-button size="sm" @click="verificarPaciente()">Actualizar</b-button></b-td>
      </b-tr>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  name: "ActualizarPaciente",
  components: {
  },
  props: {},
  data: () => ({
    datosPaciente: null,
    datosVerificacion: null,
    idPaciente: null,
    fieldPaciente: [
      { key: "idPaciente", label: "ID Paciente" },
      { key: "nombreCompleto", label: "Nombre del paciente" },
      { key: "fechaNacimiento", label: "Fecha de nacimiento" },
      { key: "tipoPacienteKPI", label: "Tipo de paciente" },
    ],
    loading: false,
  }),
  created() {
    this.urlBase = this.$api;  
    this.cargando = false;
  },

  methods: {
    traerDatosPaciente() {
      this.loading = true;
      this.cargando = true;
      const params = {
        idPaciente: this.idPaciente
      }
      let urlPaciente =
        this.$api +
        "paciente/traerDatosPx" ;

      this.$http
        .post(urlPaciente, params)
        .then((response) => {
          this.datosPaciente = response.data.data;
          
        })
        .catch((err) => {
         console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },


    verificarPaciente() {
      this.loading = true;
      const params = {
        idPaciente: this.idPaciente
      }
      let urlPaciente =
        this.$api +
        "paciente/verificarpx" ;

      this.$http
        .post(urlPaciente, params)
        .then((response) => {
          this.datosVerificacion = response.data.data;
          console.log("this.datosVerificacion",this.datosVerificacion)

          if(!this.datosVerificacion.pacienteTeniaKPI){
            this.$swal({
              icon: "info",
              title: "El paciente no tiene KPI",
              text: "¿Desea crear el kpi?",
              confirmButtonText: "Sí, continuar",
              cancelButtonText: "No, cancelar",
              confirmButtonColor: "#0e6ba9",
            }).then((result) => {
              if (result.isConfirmed) {
                this.actualizarPaciente();
              }
            })
          }else if(this.datosVerificacion.pacienteTeniaKPI && this.datosVerificacion.pacienteRequiereActualizar){
            this.$swal({
              icon: "info",
              title: "El paciente no es del tipo correcto",
              html: (this.datosVerificacion.pacienteTienePlan 
                ? "Paciente tiene plan<br>" 
                : "Paciente no tiene plan<br>") + 
                (this.datosVerificacion.pacientePlanKPI 
                    ? "Paciente registrado con plan<br><br>" 
                    : "Paciente registrado como natural<br><br>") + 
                "¿Desea corregir el tipo de paciente?",
              confirmButtonText: "Sí, continuar",
              cancelButtonText: "No, cancelar",
              confirmButtonColor: "#0e6ba9",
            }).then((result) => {
              if (result.isConfirmed) {
                this.actualizarPaciente();
              }
            })
          }else if(!this.datosVerificacion.pacienteRequiereActualizar){
            this.$swal({
              icon: "info",
              title: "El paciente está bien categorizado",
              text: "No es necesario actualizar al paciente",
              confirmButtonText: "De acuerdo",
              confirmButtonColor: "#0e6ba9"
            })
          }
        })
        .catch((err) => {
          this.showErroMsg(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    actualizarPaciente(){
      this.loading = true;
      this.datosVerificacion.idPaciente = this.idPaciente;

      let urlPaciente =
        this.$api +
        "paciente/actualizarpx" ;

      this.$http
        .post(urlPaciente, this.datosVerificacion)
        .then((response) => {
          if(response){
            this.$swal({
              icon: "info",
              title: "Paciente actualizado correctamente",
              confirmButtonText: "De acuerdo",
              confirmButtonColor: "#0e6ba9"
            })
          }
          this.traerDatosPaciente();  
        }).catch((err) => {
          console.error(err);
          this.$swal({
              icon: "error",
              title: "Ocurrió un error",
              text: "Ocurrió un error, por favor inténtelo más tarde",
              confirmButtonText: "De acuerdo",
              confirmButtonColor: "#0e6ba9"
            })
        }).finally(() => {
          this.loading = false;
        });
    }
  },
};
</script>

<style></style>
